/**
 * DonutGauge — SVG donut with a centered percentage + label, and a legend of
 * distribution rows (label · bar · pct). Mirrors the mock's 76px gauge.
 */
const R = 26;
const CIRC = 2 * Math.PI * R; // ≈ 163.36

export default function DonutGauge({
  pct = 0,
  centerLabel,
  centerSub,
  arcColor = "var(--rust-600)",
  trackColor = "var(--slate-200)",
  legend = [],
  heading,
}) {
  const dash = (Math.max(0, Math.min(100, pct)) / 100) * CIRC;
  return (
    <div style={{ borderTop: "1px solid var(--divider)", marginTop: 20, paddingTop: 16 }}>
      {heading && (
        <div
          className="text-[11px] font-bold ciso-cap"
          style={{ color: "var(--text-muted)" }}
        >
          {heading}
        </div>
      )}
      <div className="flex items-center gap-5" style={{ marginTop: 14 }}>
        <svg width="76" height="76" viewBox="0 0 76 76" style={{ flex: "0 0 auto" }}>
          <circle cx="38" cy="38" r={R} fill="none" stroke={trackColor} strokeWidth="9" />
          <circle
            cx="38"
            cy="38"
            r={R}
            fill="none"
            stroke={arcColor}
            strokeWidth="9"
            strokeDasharray={`${dash.toFixed(1)} ${CIRC.toFixed(1)}`}
            strokeLinecap="round"
            transform="rotate(-90 38 38)"
          />
          <text
            x="38"
            y="37"
            textAnchor="middle"
            style={{ fontFamily: "var(--font-mono)", fontSize: 15, fontWeight: 600, fill: "var(--ink)" }}
          >
            {centerLabel}
          </text>
          {centerSub && (
            <text
              x="38"
              y="49"
              textAnchor="middle"
              style={{
                fontFamily: "var(--font-sans)",
                fontSize: 8,
                fontWeight: 700,
                fontVariant: "small-caps",
                letterSpacing: "0.08em",
                fill: "var(--text-muted)",
              }}
            >
              {centerSub}
            </text>
          )}
        </svg>
        <div className="flex-1 min-w-0 flex flex-col gap-[11px]">
          {legend.map((row) => (
            <div key={row.label} className="flex items-center gap-[10px]">
              <span
                style={{ width: 7, height: 7, flex: "0 0 auto", borderRadius: "50%", background: row.color }}
              />
              <span
                className="text-[12.5px]"
                style={{ color: "var(--text-secondary)", flex: "0 0 auto", width: 108 }}
              >
                {row.label}
              </span>
              <span
                style={{
                  flex: "1 1 0%",
                  height: 6,
                  borderRadius: 999,
                  background: "var(--slate-200)",
                  overflow: "hidden",
                }}
              >
                <span
                  style={{
                    display: "block",
                    height: "100%",
                    width: `${Math.min(100, row.pct)}%`,
                    background: row.color,
                    borderRadius: 999,
                  }}
                />
              </span>
              <span
                className="ciso-num text-[11.5px]"
                style={{ color: "var(--ink)", width: 46, textAlign: "right" }}
              >
                {row.pct}%
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
